import { __decorate } from "tslib";
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { deleteTask, zoneList } from '@blade-sxp/task-management/api/off-duty-detection/index';
import authItem from '@blade/common/components/auth/auth-item.vue';
import tableHeader from '@blade-sxp/task-management/components/table-header.vue';
import errDialog from '@blade-sxp/task-management/pages/create-task/components/err-dialog.vue';
import { queryDeviceTaskErrorConfigs } from '@blade-sxp/task-management/api/creat-task/index';
let default_1 = class default_1 extends Vue {
    multipleTable;
    data;
    loading;
    pagination;
    refresh;
    goPage;
    changeParam;
    libraryList;
    failDialogVisible = false;
    gridData = [];
    errImg = require('@blade-sxp/task-management/assets/subtract.png');
    union = require('@blade-sxp/task-management/assets/union.png');
    taskStatus = '';
    popoverStatus;
    filterZone = [];
    filterTaskStatus = [];
    changeLoading(loading) {
        if (loading === false && this.popoverStatus) {
            this.$refs.popover.showPopper = false;
            this.popoverStatus = false;
        }
    }
    get showStr() {
        return (item) => {
            return item.start && item.end ? `${item.start.replace(/-/g, '.')}-${item.end.replace(/-/g, '.')}` : '';
        };
    }
    get pushLibrary() {
        return (item) => {
            const rulesList = item.bizTaskConfig.bigDataConfig?.rules || [];
            return rulesList.map((e) => {
                return this.libraryList.find((item) => item.libId === e.pushLibrary);
            });
        };
    }
    ellipsisName(str) {
        return str?.length > 10 ? `${str.slice(0, 10)}...` : str;
    }
    initI18n() {
        this.filterZone = [];
        this.filterTaskStatus = [
            { text: String(this.$t('effect')), value: 'ENABLE' },
            { text: String(this.$t('noEffective')), value: 'DISABLE' },
            { text: String(this.$t('abnormal')), value: 'ERROR' },
            // { text: String(this.$t('toStart')), value: 'TO_BE_ENABLED' },
        ];
    }
    getStatusInfo(code) {
        switch (code) {
            case 'ENABLE':
                return {
                    color: '#5AC262',
                    text: String(this.$t('effect')),
                };
            case 'DISABLE':
                return {
                    color: 'rgba(0,0,0,0.25)',
                    text: String(this.$t('noEffective')),
                };
            case 'ERROR':
                return {
                    color: 'rgba(250,100,0,1)',
                    text: String(this.$t('abnormal')),
                };
            // case 'TO_BE_ENABLED':
            //   return {
            //     color: 'rgba(0,0,0,0.25)',
            //     text: String(this.$t('toStart')),
            //   };
            default:
                return {};
        }
    }
    filterZoneTag(value, row) {
        return row.zoneId === value;
    }
    filterTaskStatusTag(value, row) {
        return row.status === value;
    }
    handleSizeChange(val) {
        this.changeParam('size', val);
    }
    handleCurrentChange(val) {
        this.changeParam('current', val);
    }
    // handleBigDataResult(val: tableData) {
    //   this.$router.push({
    //     path: '/statistics/big-data-result',
    //     query: {
    //       id: val.id,
    //       name: val.name
    //     }
    //   });
    // }
    getZoneList() {
        let param = {
            externalBizFrom: '',
            keywords: '',
        };
        zoneList(param).then((res) => {
            if (Array.isArray(res)) {
                for (let i in res) {
                    if (res[i].children.length !== 0) {
                        let obj = {
                            text: '',
                            value: 0,
                        };
                        obj.text = res[i].name;
                        obj.value = res[i].id;
                        this.filterZone.push(obj);
                        for (let j in res[i].children) {
                            let objChildren = {
                                text: '',
                                value: 0,
                            };
                            objChildren.text = res[i].children[j].name;
                            objChildren.value = res[i].children[j].id;
                            this.filterZone.push(objChildren);
                        }
                    }
                }
            }
            else if (Object.prototype.toString.call(res) === '[object Object]') {
                if (res.children.length !== 0) {
                    let obj = {
                        text: '',
                        value: 0,
                    };
                    obj.text = res.name;
                    obj.value = res.id;
                    this.filterZone.push(obj);
                    for (let j in res.children) {
                        let objChildren = {
                            text: '',
                            value: 0,
                        };
                        objChildren.text = res.children[j].name;
                        objChildren.value = res.children[j].id;
                        this.filterZone.push(objChildren);
                    }
                }
            }
        });
    }
    CheckedKeys(zoneId) {
        this.changeParam('zoneId', zoneId);
    }
    showHandle() {
        this.popoverStatus = true;
    }
    /**
     *@Description: 删除任务
     */
    handleDelete(rowData) {
        if (rowData.taskType === 'BIG_DATA' && rowData.status === 'ENABLE') {
            this.$message({ message: `${this.$t('taskRunningHint')}`, type: 'error' });
            return;
        }
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('bigdataDeleteWarning')}`;
        this.$elconfirm(deviceConfirmDelete, `${this.$t('common.warning')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.no')}`,
            confirmButtonText: confirm,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    deleteTask(rowData.id)
                        .then(() => {
                        this.$message({
                            message: this.$t('deletedSuccessfully'),
                            type: 'success',
                        });
                        this.refresh();
                    })
                        .catch(() => {
                        // this.$message({ message: err, type: 'error' });
                    });
                }
            },
        });
    }
    /**
     *@Description: 查看任务结果
     */
    handleResult(...rest) {
        this.$emit('result', ...rest);
    }
    /**
     *@Description: 编辑任务
     */
    handleEdit(id) {
        this.$router.push({
            path: '/dataMining/bigData/big-data',
            query: {
                taskType: 'BIG_DATA',
                id,
                type: 'update',
            },
        });
    }
    /**
     *@Description: 查看任务详情
     */
    goView(id) {
        this.$refs[`popover-${id}`].doClose();
        this.goPage(id, 'detail');
    }
    sortChange(order) {
        if (order.order === 'ascending') {
            this.changeParam('sort', 'ASC');
        }
        else {
            this.changeParam('sort', 'DESC');
        }
    }
    cellClick(row, column) {
        if (column.property === 'name') {
            this.goView(Number(row.id));
        }
    }
    showErr(id) {
        queryDeviceTaskErrorConfigs(id).then((res) => {
            this.gridData = res;
            this.failDialogVisible = true;
        });
    }
    filterChange(e) {
        if (e.taskStatus.length > 0) {
            this.taskStatus = e.taskStatus[0];
        }
        else {
            this.taskStatus = '';
        }
        this.changeParam('taskStatus', this.taskStatus);
    }
    mounted() {
        this.initI18n();
    }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "pagination", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
__decorate([
    Prop()
], default_1.prototype, "goPage", void 0);
__decorate([
    Prop()
], default_1.prototype, "changeParam", void 0);
__decorate([
    Prop()
], default_1.prototype, "libraryList", void 0);
__decorate([
    Watch('loading', { immediate: true })
], default_1.prototype, "changeLoading", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'OffDutyDetection',
        components: { authItem, tableHeader, errDialog },
        i18n: {
            messages: {
                zh: {
                    taskName: '任务名称',
                    deviceName: '设备名称',
                    associateCluster: '关联聚类',
                    zoneName: '所属区域',
                    status: '任务状态',
                    creator: '创建人',
                    effect: '启用',
                    noEffective: '停用',
                    toStart: '待启动',
                    abnormal: '异常',
                    confirmDeleteAttr: '确认删除?',
                    cancel: '取消',
                    operation: '操作',
                    delete: '确认',
                    deletedSuccessfully: '删除成功',
                    total: '总共 {msg} 条',
                    deleteMsg: '确定删除这个任务吗？',
                    deleteEnter: '该任务正在执行中，请暂停任务后再次尝试删除任务操作',
                    creationTime: '创建时间',
                    validTime: '有效时间',
                    alarmType: '告警类型',
                    queueNumber: '排队人数',
                    queueTime: '排队时间',
                    always: '永久生效',
                    fileAction: '聚档结果',
                    bigDataAction: '结果',
                    clusterDeleteWarning: '删除任务将同时删除产生的聚档结果，是否确认继续删除该任务？',
                    bigdataDeleteWarning: '删除该任务仅会清除任务分析数据，不影响聚类任务或已经生成的人像数据结果。',
                    taskRunningHint: '该任务正在运行中，请在操作前先结束任务',
                },
                'en-us': {
                    validTime: 'Valid Time',
                    total: 'Total {msg} Items',
                    taskName: 'Task Name',
                    deviceName: 'Device',
                    associateCluster: 'Associated Clustering',
                    operation: 'Option',
                    zoneName: 'Area Name',
                    status: 'Status',
                    creator: 'Creator',
                    effect: 'Running',
                    noEffective: 'Disabled',
                    toStart: 'Waiting',
                    abnormal: 'Abnormal',
                    confirmDeleteAttr: 'Are you sure to delete the task？',
                    cancel: 'Cancel',
                    delete: 'Delete',
                    deletedSuccessfully: 'Deleted successfully',
                    deleteMsg: 'Are you sure to delete this task?',
                    deleteEnter: 'The task is in progress, please pause the task and try to delete the task again',
                    creationTime: 'Creation Time',
                    alarmType: 'Task Type',
                    queueNumber: 'Queue Length',
                    queueTime: 'Waiting Time',
                    always: 'Always',
                    fileAction: 'Poly file results',
                    bigDataAction: 'Result',
                    clusterDeleteWarning: 'Delete a task will also delete the generated file clustering result of the task. Do you want to continue deleting the task?',
                    bigdataDeleteWarning: 'Deleting this task will clear its analysis data only, the clustering task and generated portrait data will not be affected.',
                    taskRunningHint: 'The task is in the running state. End the task before performing any operation.',
                },
            },
        },
    })
], default_1);
export default default_1;
